import {isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  platformId = inject(PLATFORM_ID)

  constructor() { }
  loadScript() {
    if(!isPlatformBrowser(this.platformId)) return
    const googleMaps = document.getElementById("chilepasajes-web-gm")
    if (!googleMaps) {    
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&loading=async`;
      script.id = "chilepasajes-web-gm"
      document.body.appendChild(script);
    }
  }
}
